import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMsg.scss';


class ErrorMsg extends React.Component {
  render() {
    return (
      <div className="errorMsg">
        {this.props.text}
      </div>
    )
  }
}

ErrorMsg.prototypes = {
  text: PropTypes.string,
};

export default ErrorMsg;